import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class Box extends Div
{
    constructor(className: string, content: appendable[])
    {
        super(className);
        this.Append(...content);
    }
}
